import React, {Component} from 'react';
import './QuestionForm.css';
import * as _ from 'lodash';
import * as request from 'superagent';

class QuestionForm extends Component {

    constructor() {
        super();
        this.state = this.getInitialState();
    }

    componentDidMount() {
        this.messageModal = document.getElementById('contact-modal');
    }

    getInitialState = () => {
        let formData = {
            email: '',
            name: '',
            content: ''
        };
        let validationErrors = _.mapValues(formData, r => 'invalid');
        return {
            formData: formData,
            formErrors: validationErrors,
            formValid: [false],
            showErrors: false,
            sent: false
        };
    };
    resetState = () => {
        this.setState(this.getInitialState());
    };

    handleUserInput = (e) => {
        const name = e.target.name;
        const id = e.target.id;
        const value = e.target.value;
        const formData = this.state.formData;
        formData[id] = value;
        this.setState({formData: formData},
            () => {
                this.validateField(id, name, value);
            });
    };


    validateField(fieldId, fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;

        switch (fieldName) {
            case 'email':
                let emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors[fieldId] = emailValid ? '' : ' is invalid';
                break;
            default:
                let lengthValid = value.length >= 2;
                fieldValidationErrors[fieldId] = lengthValid ? '' : ' is too short';
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors
        }, this.validateForm);
    }

    validateForm() {
        const formErrors = this.state.formErrors;
        let valid = !formErrors.name && !formErrors.email;
        const formValid = this.state.formValid;
        formValid[0] = valid;
        this.setState({
            formValid: formValid
        });
    }

    errorClass(error) {
        return (error.length === 0 || !this.state.showErrors ? '' : 'has-error');
    }

    send() {
        if (this.state.formValid[0]) {
            this.setState({
                showErrors: false,
                sent: true
            });
            this.sendRequest();
            setTimeout(() => {
                this.resetState();
                this.closeMessageModal();
            }, 4000);
        } else {
            this.setState({
                showErrors: true
            });
        }
    }

    sendRequest() {
        request
            .post('https://projektid.filmiklubi.ee/backend/mailing/question')
            .send(this.state.formData)
            .end(function (err, res) {
                if (err || !res.ok) {
                    alert('Proovi natukese aja pärast uuesti, või saada meile email info@filmiklubi.ee');
                }
            });
    }

    closeMessageModal() {
        this.messageModal.style.display = 'none';
        document.body.classList.remove('no-scroll');
    }

    render() {
        return (
            <div className="contact-modal-content">
                <div className={`email-sent ${this.state.sent ? 'show-email-sent' : 'hide-email-sent'}`}>
                    <p>Sõnum on saadetud, vastame sulle esimesel võimalusel!</p>
                </div>
                <div className="close-button" onClick={e => this.closeMessageModal()}>
                    <span className="line line1"/>
                    <span className="line line2"/>
                </div>
                <div className="question">
                    <div className={`${this.state.sent ? 'hide-contact-modal-content' :
                        'show-contact-modal-content'}`}>
                        <div className="information">
                            <h1 className="modal-title">
                                Küsi pakkumist
                            </h1>
                            <span className="horizontal-divider"/>
                            <p className="send-email-top">Või saada meile kiri info@filmiklubi.ee</p>
                            <div className={`form-group ${this.errorClass(this.state.formErrors.name)}`}>
                                <h1 className="placeholder">Nimi</h1>
                                <input id="name" type="text" spellCheck="false" name="name" required
                                       value={this.state.formData.name}
                                       onChange={(event) => this.handleUserInput(event)}/>
                                <span className="bar"/>
                            </div>
                            <div className={`form-group ${this.errorClass(this.state.formErrors.email)}`}>
                                <h1 className="placeholder">Email</h1>
                                <input id="email" type="text" spellCheck="false" name="email" required
                                       value={this.state.formData.email}
                                       onChange={(event) => this.handleUserInput(event)}/>
                                <span className="bar"/>
                            </div>
                            <p className="send-email">Või saada meile kiri info@filmiklubi.ee</p>
                            <span className="horizontal-divider-bottom"/>
                        </div>
                        <span className="vertical-divider"/>
                        <div className="message">
                            <h1 className="placeholder">Sõnum</h1>
                            <textarea id="content" className="message-content" spellCheck="false"
                                      value={this.state.formData.content}
                                      placeholder="Kirjuta oma küsimus siia..."
                                      onChange={(event) => this.handleUserInput(event)}/>
                            <button className="send-message" onClick={e => this.send()}>Saada</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default QuestionForm;



// WEBPACK FOOTER //
// ./src/questionform/QuestionForm.js